module.exports = __webpack_public_path__ + "media/images/flags/64/Micronesia-ffd820266b7d9dc25750ff831ac9201c.png";